import echartsItem from '@/views/system/customManage/echartsItem.vue';
import timeModel from './timeModel.vue';
import moment from 'moment';
import { getDate } from '@/utils/public';
export default {
  components: {
    echartsItem,
    timeModel
  },
  props: {
    previewList: {
      type: Array,
      default() {
        return [];
      }
    },
    background: {
      type: Boolean,
      default: false
    },
    queryMethod: {
      type: String,
      default: ''
    },
    timeFrame: {
      type: String,
      default: ''
    },
    dateFrame: {
      type: Array,
      default() {
        return [];
      }
    },
    dateFrame0: {
      type: Object,
      default() {
        return {};
      }
    },
    dateFrame1: {
      type: Object,
      default() {
        return {};
      }
    },
    dateFrame2: {
      type: Object,
      default() {
        return {};
      }
    },
    dateFrame3: {
      type: Object,
      default() {
        return {};
      }
    },
    dateFrame4: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      url: require('@/assets/vr/IMG_6408.png'),
      timer1: '',
      isTimeShow: false,
      selectPriceDate: '',
      spinning: false,
      offsetDays: 86400000 * 365,
      spinning0: false,
      spinning1: false,
      spinning2: false,
      spinning3: false,
      spinning4: false
    };
  },
  watch: {
    previewList: {
      handler() {
        this.timer1 = new Date().getTime();
        this.spinning = false;
        this.spinning0 = false;
        this.spinning1 = false;
        this.spinning2 = false;
        this.spinning3 = false;
        this.spinning4 = false;
      }
    },
    deep: true
  },
  methods: {
    formatDate(date) {
      let _date = date.split('~');
      _date = moment(_date[0]).format(this.getFormatDate()) + '~' + moment(_date[1]).format(this.getFormatDate());
      return _date || '';
    },
    titleFun(val) {
      let name = '';
      if (val && val.panelConfig && val.panelConfig.name) {
        name = val.panelConfig.name;
      }
      return name;
    },
    disabledDate(current) {
      if (this.selectPriceDate) {
        let selectV = moment(this.selectPriceDate, 'YYYY-MM-DD').valueOf();
        return current > moment().add(0, 'days') || current < moment(new Date(selectV - this.offsetDays), 'YYYY-MM-DD');
      } else {
        return current > moment().add(0, 'days');
      }
    },
    onChangeTime(date) {
      if (this.spinning) {
        return false;
      }
      this.selectPriceDate = '';
      this.spinning = true;
      this.$emit('setDateFrame', date);
    },
    tabFun(val) {
      if (this.spinning) {
        return false;
      }
      this.spinning = true;
      this.$emit('setTmeFrame', val);
    },
    onSinglesTime(val) {
      this.isTimeShow = true;
      let obj = this['dateFrame' + val];
      if (!obj.timeName) {
        obj.timeFrame = this.previewList[val].timeFrame;
      }
      this.$nextTick(() => {
        this.$refs.timeRef.init(obj, val);
      });
    },
    timeChangeOk(val, num) {
      this['spinning' + num] = true;
      this.$emit('setDateFrameSingles', val, this.previewList[num], num);
    },
    getTimeFrame(val, cont) {
      if (val.dateFrame && val.dateFrame.length != 0) {
        return val.timeName;
      } else if (val.timeFrame) {
        const dateInfo = getDate(val.timeFrame);
        return dateInfo.startTime + '~' + dateInfo.endTime;
      } else {
        const dateInfo = getDate(cont);
        return dateInfo.startTime + '~' + dateInfo.endTime;
      }
    },
    calendarPriceRangeChange(date) {
      this.selectPriceDate = date[0];
    }
  }
};